import { usePatchedNavigate } from "src/Hooks/usePatchedNavigate";
import { useQuery } from "src/Hooks/useReactQuery";
import APP_ROUTES from "src/routes/routes";
import { getSequences } from "src/services/sequences";

const useGetSequenceList = ({ page = 1, limit = 9999999, q, order_by, yamcs_package_id, test_package_id, onSettledCallback }) => {
  const navigate = usePatchedNavigate();
  const queryFn = () => {
    const params = {
      page,
      limit,
      ...(q && { q }),
      ...(order_by && { order_by }),
      ...(yamcs_package_id && { yamcs_package_id }),
      ...(test_package_id && { test_package_id }),
    };
    return getSequences(params);
  };

  const { data, isLoading, isError, error, refetch, isFetching } = useQuery({
    queryKey: ["getSequences", q, yamcs_package_id, page, test_package_id],
    queryFn,
    enabled: true,
    onError: (error) => {
      if (error?.response?.status === 404) {
        navigate(APP_ROUTES.NOT_FOUND);
      }
    },
    onSettled: () => {
      if (onSettledCallback) {
        onSettledCallback();
      }
    },
  });

  return {
    sequenceList: data,
    sequenceListRefetch: refetch,
    isLoadingSequenceList: isLoading,
    isErrorSequenceList: isError,
    errorSequenceList: error,
    isFetchingSequenceList: isFetching,
  };
};

export default useGetSequenceList;
